
import {
  Box, Button, Grid, TextField, Typography, Paper, InputLabel, Select, MenuItem, FormControl
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import showTimeServices from "../../services/externalServices/TicketServices/showTimeServices"
import React, { useEffect, useState } from 'react';
import editicon from '../../../assets/images/edit-icon.png'
import { MovieSharp, ShowChart } from '@mui/icons-material';
import { FaTrashAlt, FaPlus } from 'react-icons/fa';
import moment from 'moment';


// const EditValidity = () => {
//     const { state } = useLocation();
//     const navigate = useNavigate();
//     const { schedule } = state || {};

//     const [validityFrom, setValidityFrom] = useState('');
//     const [validityUntil, setValidityUntil] = useState('');
//     const [theatreDetails, setTheatreDetails] = useState([]);
//     const [isReadyForBooking, setIsReadyForBooking] = useState(false); // Add this state

//     useEffect(() => {
//         if (schedule) {
//             setValidityFrom(dayjs(schedule.validityFrom).format('YYYY-MM-DD'));
//             setValidityUntil(dayjs(schedule.validityUntil).format('YYYY-MM-DD'));
//             // setIsReadyForBooking(schedule.movieId?.isReadyForBooking || false); // Initialize from movie data

//             setIsReadyForBooking(
//                 schedule.theatreDetails.some(theatre => theatre.isReadyForBooking)
//               );
//             // Convert showtimes into separate hour, minute, and period
//             const updatedTheatreDetails = schedule.theatreDetails.map((theatre) => {
//                 return {
//                     ...theatre,
//                     // showTimes: theatre.showTimes.map((showtime) => {
//                     //     const cleanedTime = showtime.trim();  // Remove any extra spaces
//                     //     const regex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i; // Regex to capture hour, minute, and period
//                     //     const match = cleanedTime.match(regex);

//                     //     if (match) {
//                     //         const [, hour, minute, period] = match;
//                     //         return { hour: String(hour).padStart(2, "0"), minute, period: period.toUpperCase() };
//                     //     }

//                     //     return { hour: "00", minute: "00", period: "AM" };  // Default fallback
//                     // }),


//                     showTimes: (theatre.shows || []).map((show) => {
//                         const cleanedTime = show.time?.trim() || '';
//                         const regex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
//                         const match = cleanedTime.match(regex);

//                         if (match) {
//                             const [, hour, minute, period] = match;
//                             return {
//                                 hour: String(hour).padStart(2, "0"),
//                                 minute,
//                                 period: period.toUpperCase(),
//                                 language: show.language || '',
//                                 format: show.format || ''
//                             };
//                         }

//                         return { hour: "00", minute: "00", period: "AM", language: '', format: '' };
//                     })

//                 };
//             });

//             setTheatreDetails(updatedTheatreDetails);
//         }
//     }, [schedule]);


//     const handleShowTimeChange = (index, timeIndex, field, value) => {
//         const updated = [...theatreDetails];
//         updated[index].showTimes[timeIndex][field] = value;
//         setTheatreDetails(updated);
//     };

//     // const handleAddShowTime = (index) => {
//     //     const updated = [...theatreDetails];
//     //     updated[index].showTimes.push({ hour: "12", minute: "00", period: "AM" }); // Default values
//     //     setTheatreDetails(updated);
//     // };

//     const handleDeleteShowTime = (index, timeIndex) => {
//         if (window.confirm("Are you sure you want to delete this showtime?")) {
//             const updated = [...theatreDetails];
//             updated[index].showTimes.splice(timeIndex, 1); // Remove selected showtime
//             setTheatreDetails(updated);
//         }
//     };

//     // const handleAddShowTime = (theatreIdx, positionIdx) => {
//     //     const newShowTimes = [...theatreDetails[theatreIdx].showTimes];
//     //     newShowTimes.splice(positionIdx + 1, 0, { hour: "01", minute: "00", period: "AM" });
//     //     updateTheatreDetails(theatreIdx, newShowTimes);
//     //   };

//     const handleAddShowTime = (theatreIdx, positionIdx) => {
//         const updated = [...theatreDetails];
//         updated[theatreIdx].showTimes.splice(positionIdx + 1, 0, { hour: "00", minute: "", period: "" }); // empty values
//         setTheatreDetails(updated);
//     };



//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = {
//                 validityFrom,
//                 validityUntil,
//                 theatreDetails,
//                 isReadyForBooking // Include the checkbox value
//             };

//             // Convert back showTimes into a single string (e.g., '10:30 AM')
//             // const updatedTheatreDetails = theatreDetails.map((theatre) => {
//             //     return {
//             //         ...theatre,
//             //         // showTimes: theatre.showTimes.map(
//             //         //     (showtime) => `${showtime.hour}:${showtime.minute} ${showtime.period}`
//             //         // ),
//             //         shows: theatre.showTimes.map((showtime) => ({
//             //             time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
//             //             language: showtime.language,
//             //             format: showtime.format
//             //           }))
//             //     };
//             // });



//             const updatedTheatreDetails = theatreDetails.map((theatre) => ({
//                 theatreId: theatre.theatreId._id || theatre.theatreId,
//                 isArchived: theatre.isArchived || false,
//                 isReadyForBooking: theatre.isReadyForBooking || false,
//                 shows: theatre.showTimes.map((showtime) => ({
//                   time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
//                   language: showtime.language,
//                   format: showtime.format
//                 }))
//               }));



//             payload.theatreDetails = updatedTheatreDetails;

//             console.log('payload',payload);

//             const response = await showTimeServices.updateShowSchedule(schedule._id, payload);

//             //   console.log('response', response);
//             alert(response.message);
//             navigate('/showSchedules');
//         } catch (error) {
//             console.error(error);
//             alert('Failed to update show schedule');
//         }
//     };

//     if (!schedule) return <Typography color="error">No schedule selected</Typography>;

//     return (
//         <div className="p-8 bg-white rounded-xl shadow-lg max-w-4xl mx-auto my-8">
//             <h1 className="text-3xl font-bold text-gray-800 mb-6 flex gap-3 items-center">
//                 <img src={editicon} alt="edit-icon" className="w-12 h-12" /> Edit Show Schedule
//                 {/* <EditIcon className='w-6 h-6 p-4'/>Edit Show Schedule */}
//             </h1>

//             <p className="text-lg text-gray-600 mb-8">
//                 <MovieSharp /> Movie: <span className="font-semibold">{schedule.movieId?.name}</span>
//             </p>

//             <form onSubmit={handleSubmit} className="space-y-8">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">
//                             Validity From
//                         </label>
//                         <input
//                             type="date"
//                             value={validityFrom}
//                             onChange={(e) => setValidityFrom(e.target.value)}
//                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             required
//                         />
//                     </div>

//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">
//                             Validity Until
//                         </label>
//                         <input
//                             type="date"
//                             value={validityUntil}
//                             onChange={(e) => setValidityUntil(e.target.value)}
//                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                             required
//                         />
//                     </div>
//                 </div>

//                 {theatreDetails.map((t, idx) => (
//                     <div key={idx} className="bg-gray-50 p-6 rounded-xl">
//                         <h2 className="text-xl font-semibold text-gray-800 mb-4">
//                             <ShowChart /> {t.theatreId?.name}
//                         </h2>

//                         <div className="space-y-4">
//                             {t.showTimes.map((showtime, timeIdx) => (


//                                 <div key={timeIdx} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Hour</label>
//                                         <select
//                                             value={showtime.hour}
//                                             onChange={(e) => handleShowTimeChange(idx, timeIdx, 'hour', e.target.value)}
//                                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                                         >
//                                             {/* {[...Array(13).keys()].map((i) => (
//                                                 <option key={i + 1} value={String(i + 1).padStart(2, "0")}>
//                                                     {String(i + 1).padStart(2, "0")}
//                                                 </option>
//                                             ))} */}
//                                             {[...Array(13).keys()].map((i) => (
//                                                 <option key={i} value={String(i).padStart(2, "0")}>
//                                                     {String(i).padStart(2, "0")}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Minute</label>
//                                         <select
//                                             value={showtime.minute}
//                                             onChange={(e) => handleShowTimeChange(idx, timeIdx, 'minute', e.target.value)}
//                                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                                         >
//                                             {[...Array(60).keys()].map((i) => (
//                                                 <option key={i} value={String(i).padStart(2, "0")}>
//                                                     {String(i).padStart(2, "0")}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">AM/PM</label>
//                                         <select
//                                             value={showtime.period}
//                                             onChange={(e) => handleShowTimeChange(idx, timeIdx, 'period', e.target.value)}
//                                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                                         >
//                                             <option value="AM">AM</option>
//                                             <option value="PM">PM</option>
//                                         </select>
//                                     </div>


//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Language</label>
//                                         <select
//                                             value={showtime.language}
//                                             onChange={(e) => handleShowTimeChange(idx, timeIdx, 'language', e.target.value)}
//                                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                                         >
//                                             <option value="">Select</option>
//                                             {["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"].map((lang) => (
//                                                 <option key={lang} value={lang}>{lang}</option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Format</label>
//                                         <select
//                                             value={showtime.format}
//                                             onChange={(e) => handleShowTimeChange(idx, timeIdx, 'format', e.target.value)}
//                                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                                         >
//                                             <option value="">Select</option>
//                                             <option value="2D">2D</option>
//                                             <option value="3D">3D</option>
//                                         </select>
//                                     </div>



//                                     <div className="flex justify-center items-center space-x-4">
//                                         <button
//                                             type="button"
//                                             onClick={() => handleDeleteShowTime(idx, timeIdx)}
//                                             className="text-red-500 hover:text-red-700 text-2xl flex items-center"
//                                             title="Delete showtime"
//                                         >
//                                             <FaTrashAlt className="mr-1" /> {/* Trash icon */}
//                                             {/* Delete */}
//                                         </button>

//                                         <button
//                                             type="button"
//                                             onClick={() => handleAddShowTime(idx, timeIdx)}
//                                             className="text-green-500 hover:text-green-700 text-xl flex items-center"
//                                             title="Add showtime after"
//                                         >
//                                             <FaPlus className="mr-1" /> {/* Plus icon */}
//                                             {/* Add */}
//                                         </button>
//                                     </div>
//                                     {/* 
//                                     <div className="flex justify-center items-center">
//                                         <button
//                                             type="button"
//                                             onClick={() => handleDeleteShowTime(idx, timeIdx)}
//                                             className="text-red-500 hover:text-red-700 text-2xl"
//                                             title="Delete showtime"
//                                         >
//                                             🗑️
//                                         </button>

//                                         <button
//                                             type="button"
//                                             onClick={() => handleAddShowTime(idx, timeIdx)}
//                                             className="text-green-500 hover:text-green-700 text-xl"
//                                             title="Add showtime after"
//                                         >
//                                             ➕
//                                         </button>
//                                     </div> */}
//                                 </div>

//                             ))}



//                         </div>
//                     </div>
//                 ))}

//                 {/* Add the Ready for Booking checkbox */}
//                 <div className="flex items-center p-4 bg-gray-50 rounded-lg">
//                     <input
//                         type="checkbox"
//                         id="readyForBooking"
//                         checked={isReadyForBooking}


//                         onChange={(e) => setIsReadyForBooking(e.target.checked)}
//                         className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
//                     />
//                     <label htmlFor="readyForBooking" className="ml-3 text-sm font-medium text-gray-700">
//                         Ready for Booking
//                     </label>
//                     <span className="ml-2 text-xs text-gray-500">
//                         (Check this to make the movie immediately available for booking)
//                     </span>
//                 </div>

//                 <button
//                     type="submit"
//                     className="w-full md:w-auto px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
//                 >
//                     Update Schedule
//                 </button>
//             </form>
//         </div>
//     );
// };













// New with enabled dates 


// const EditValidity = () => {
//     const { state } = useLocation();
//     const navigate = useNavigate();
//     const { schedule } = state || {};

//     const [validityFrom, setValidityFrom] = useState('');
//     const [validityUntil, setValidityUntil] = useState('');
//     const [theatreDetails, setTheatreDetails] = useState([]);
//     const [isReadyForBooking, setIsReadyForBooking] = useState(false);
//     const [datePickerOpen, setDatePickerOpen] = useState({ theatreIdx: null, showIdx: null });


//     useEffect(() => {
//         if (schedule) {
//             setValidityFrom(dayjs(schedule.validityFrom).format('YYYY-MM-DD'));
//             setValidityUntil(dayjs(schedule.validityUntil).format('YYYY-MM-DD'));
//             setIsReadyForBooking(
//                 schedule.theatreDetails.some(theatre => theatre.isReadyForBooking)
//             );

//             const updatedTheatreDetails = schedule.theatreDetails.map((theatre) => {
//                 return {
//                     ...theatre,
//                     showTimes: (theatre.shows || []).map((show) => {
//                         const cleanedTime = show.time?.trim() || '';
//                         const regex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
//                         const match = cleanedTime.match(regex);

//                         if (match) {
//                             const [, hour, minute, period] = match;
//                             return {
//                                 hour: String(hour).padStart(2, "0"),
//                                 minute,
//                                 period: period.toUpperCase(),
//                                 language: show.language || '',
//                                 format: show.format || '',
//                                 enabledDates: show.enabledDates || []
//                             };
//                         }

//                         return { 
//                             hour: "00", 
//                             minute: "00", 
//                             period: "AM", 
//                             language: '', 
//                             format: '',
//                             enabledDates: []
//                         };
//                     })
//                 };
//             });

//             setTheatreDetails(updatedTheatreDetails);
//         }
//     }, [schedule]);

//     const handleShowTimeChange = (theatreIdx, showIdx, field, value) => {
//         const updated = [...theatreDetails];
//         updated[theatreIdx].showTimes[showIdx][field] = value;
//         setTheatreDetails(updated);
//     };

//     const handleDeleteShowTime = (theatreIdx, showIdx) => {
//         if (window.confirm("Are you sure you want to delete this showtime?")) {
//             const updated = [...theatreDetails];
//             updated[theatreIdx].showTimes.splice(showIdx, 1);
//             setTheatreDetails(updated);
//         }
//     };

//     const handleAddShowTime = (theatreIdx, showIdx) => {
//         const updated = [...theatreDetails];
//         updated[theatreIdx].showTimes.splice(showIdx + 1, 0, { 
//             hour: "00", 
//             minute: "", 
//             period: "",
//             language: "",
//             format: "",
//             enabledDates: []
//         });
//         setTheatreDetails(updated);
//     };

//     const handleDateSelection = (theatreIdx, showIdx, dates) => {
//         const updated = [...theatreDetails];
//         updated[theatreIdx].showTimes[showIdx].enabledDates = dates.map(date => formatDate(date));
//         setTheatreDetails(updated);
//     };

//     const formatDate = (date) => {
//         const d = new Date(date);
//         return d.toISOString().split('T')[0];
//     };

//     const getAllDatesInRange = () => {
//         if (!validityFrom || !validityUntil) return [];

//         const start = new Date(validityFrom);
//         const end = new Date(validityUntil);
//         const dates = [];

//         let current = new Date(start);
//         while (current <= end) {
//             dates.push(new Date(current));
//             current.setDate(current.getDate() + 1);
//         }

//         return dates;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const payload = {
//                 validityFrom,
//                 validityUntil,
//                 theatreDetails: theatreDetails.map((theatre) => ({
//                     theatreId: theatre.theatreId._id || theatre.theatreId,
//                     isArchived: theatre.isArchived || false,
//                     isReadyForBooking: theatre.isReadyForBooking || false,
//                     shows: theatre.showTimes.map((showtime) => ({
//                         time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
//                         language: showtime.language,
//                         format: showtime.format,
//                         enabledDates: showtime.enabledDates || []
//                     }))
//                 })),
//                 isReadyForBooking
//             };

//             const response = await showTimeServices.updateShowSchedule(schedule._id, payload);
//             alert(response.message);
//             navigate('/showSchedules');
//         } catch (error) {
//             console.error(error);
//             alert('Failed to update show schedule');
//         }
//     };

//     const DatePickerModal = ({ theatreIdx, showIdx, onClose, onSave }) => {
//         const [selectedDates, setSelectedDates] = useState([
//             ...theatreDetails[theatreIdx]?.showTimes[showIdx]?.enabledDates || []
//         ]);

//         const toggleDate = (date) => {
//             const dateStr = formatDate(date);
//             setSelectedDates(prev => 
//                 prev.includes(dateStr) 
//                     ? prev.filter(d => d !== dateStr)
//                     : [...prev, dateStr]
//             );
//         };

//         const allDates = getAllDatesInRange();

//         return (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                 <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
//                     <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>
//                     <div className="grid grid-cols-7 gap-1 mb-4">
//                         {allDates.map((date, idx) => {
//                             const dateStr = formatDate(date);
//                             const isSelected = selectedDates.includes(dateStr);
//                             return (
//                                 <button
//                                     key={idx}
//                                     onClick={() => toggleDate(date)}
//                                     className={`p-2 border rounded ${isSelected ? 'bg-blue-500 text-white' : 'bg-white'}`}
//                                 >
//                                     {date.getDate()}
//                                     <div className="text-xs">{date.toLocaleString('default', { month: 'short' })}</div>
//                                 </button>
//                             );
//                         })}
//                     </div>
//                     <div className="flex justify-end gap-2">
//                         <button 
//                             onClick={onClose}
//                             className="px-4 py-2 bg-gray-300 rounded"
//                         >
//                             Cancel
//                         </button>
//                         <button 
//                             onClick={() => onSave(selectedDates)}
//                             className="px-4 py-2 bg-blue-500 text-white rounded"
//                         >
//                             Save
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         );
//     };

//     if (!schedule) return <div className="text-red-500">No schedule selected</div>;

//     return (
//         <div className="p-8 bg-white rounded-xl shadow-lg max-w-4xl mx-auto my-8">
//             <h1 className="text-3xl font-bold text-gray-800 mb-6 flex gap-3 items-center">
//                 Edit Show Schedule
//             </h1>

//             <p className="text-lg text-gray-600 mb-8">
//                 Movie: <span className="font-semibold">{schedule.movieId?.name}</span>
//             </p>

//             <form onSubmit={handleSubmit} className="space-y-8">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">
//                             Validity From
//                         </label>
//                         <input
//                             type="date"
//                             value={validityFrom}
//                             onChange={(e) => setValidityFrom(e.target.value)}
//                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                             required
//                         />
//                     </div>

//                     <div className="space-y-2">
//                         <label className="block text-sm font-medium text-gray-700">
//                             Validity Until
//                         </label>
//                         <input
//                             type="date"
//                             value={validityUntil}
//                             onChange={(e) => setValidityUntil(e.target.value)}
//                             className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//                             required
//                         />
//                     </div>
//                 </div>

//                 {theatreDetails.map((theatre, theatreIdx) => (
//                     <div key={theatreIdx} className="bg-gray-50 p-6 rounded-xl">
//                         <h2 className="text-xl font-semibold text-gray-800 mb-4">
//                             {theatre.theatreId?.name}
//                         </h2>

//                         <div className="space-y-4">
//                             {theatre.showTimes.map((showtime, showIdx) => (
//                                 <div key={showIdx} className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Hour</label>
//                                         <select
//                                             value={showtime.hour}
//                                             onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'hour', e.target.value)}
//                                             className="w-full p-2 border rounded-lg"
//                                         >
//                                             {[...Array(13).keys()].map((i) => (
//                                                 <option key={i} value={String(i).padStart(2, "0")}>
//                                                     {String(i).padStart(2, "0")}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Minute</label>
//                                         <select
//                                             value={showtime.minute}
//                                             onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'minute', e.target.value)}
//                                             className="w-full p-2 border rounded-lg"
//                                         >
//                                             {[...Array(60).keys()].map((i) => (
//                                                 <option key={i} value={String(i).padStart(2, "0")}>
//                                                     {String(i).padStart(2, "0")}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">AM/PM</label>
//                                         <select
//                                             value={showtime.period}
//                                             onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'period', e.target.value)}
//                                             className="w-full p-2 border rounded-lg"
//                                         >
//                                             <option value="AM">AM</option>
//                                             <option value="PM">PM</option>
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Language</label>
//                                         <select
//                                             value={showtime.language}
//                                             onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'language', e.target.value)}
//                                             className="w-full p-2 border rounded-lg"
//                                         >
//                                             <option value="">Select</option>
//                                             {["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"].map((lang) => (
//                                                 <option key={lang} value={lang}>{lang}</option>
//                                             ))}
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2">
//                                         <label className="text-sm font-medium text-gray-700">Format</label>
//                                         <select
//                                             value={showtime.format}
//                                             onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'format', e.target.value)}
//                                             className="w-full p-2 border rounded-lg"
//                                         >
//                                             <option value="">Select</option>
//                                             <option value="2D">2D</option>
//                                             <option value="3D">3D</option>
//                                         </select>
//                                     </div>

//                                     <div className="space-y-2 col-span-2">
//                                         <button
//                                             type="button"
//                                             onClick={() => setDatePickerOpen({ theatreIdx, showIdx })}
//                                             className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200 w-full"
//                                         >
//                                             {showtime.enabledDates.length > 0 
//                                                 ? `${showtime.enabledDates.length} dates selected` 
//                                                 : "Select dates"}
//                                         </button>
//                                         <small className="text-gray-500">
//                                             {showtime.enabledDates.length > 0 
//                                                 ? showtime.enabledDates.join(', ') 
//                                                 : 'Click to select dates'}
//                                         </small>
//                                     </div>

//                                     <div className="flex justify-center items-center space-x-4 col-span-3">
//                                         <button
//                                             type="button"
//                                             onClick={() => handleDeleteShowTime(theatreIdx, showIdx)}
//                                             className="text-red-500 hover:text-red-700 text-2xl flex items-center"
//                                             title="Delete showtime"
//                                         >
//                                             <FaTrashAlt className="mr-1" />
//                                         </button>

//                                         <button
//                                             type="button"
//                                             onClick={() => handleAddShowTime(theatreIdx, showIdx)}
//                                             className="text-green-500 hover:text-green-700 text-xl flex items-center"
//                                             title="Add showtime after"
//                                         >
//                                             <FaPlus className="mr-1" />
//                                         </button>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 ))}

//                 <div className="flex items-center p-4 bg-gray-50 rounded-lg">
//                     <input
//                         type="checkbox"
//                         id="readyForBooking"
//                         checked={isReadyForBooking}
//                         onChange={(e) => setIsReadyForBooking(e.target.checked)}
//                         className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
//                     />
//                     <label htmlFor="readyForBooking" className="ml-3 text-sm font-medium text-gray-700">
//                         Ready for Booking
//                     </label>
//                     <span className="ml-2 text-xs text-gray-500">
//                         (Check this to make the movie immediately available for booking)
//                     </span>
//                 </div>

//                 <button
//                     type="submit"
//                     className="w-full md:w-auto px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
//                 >
//                     Update Schedule
//                 </button>
//             </form>

//             {/* {datePickerOpen !== null && (
//                 <DatePickerModal
//                     theatreIdx={datePickerOpen.theatreIdx}
//                     showIdx={datePickerOpen.showIdx}
//                     onClose={() => setDatePickerOpen(null)}
//                     onSave={(dates) => {
//                         handleDateSelection(datePickerOpen.theatreIdx, datePickerOpen.showIdx, dates);
//                         setDatePickerOpen(null);
//                     }}
//                 />
//             )} */}

// {datePickerOpen.theatreIdx !== null && datePickerOpen.showIdx !== null && (
//         <DatePickerModal
//             theatreIdx={datePickerOpen.theatreIdx}
//             showIdx={datePickerOpen.showIdx}
//             onClose={() => setDatePickerOpen({ theatreIdx: null, showIdx: null })}
//             onSave={(dates) => {
//                 handleDateSelection(datePickerOpen.theatreIdx, datePickerOpen.showIdx, dates);
//                 setDatePickerOpen({ theatreIdx: null, showIdx: null });
//             }}
//         />
//     )}
//         </div>
//     );
// };

// export default EditValidity;













const EditValidity = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  // const { schedule } = state || {};
  const { schedule, selectedTheatre } = state || {};


  // State management
  const [validityFrom, setValidityFrom] = useState('');
  const [validityUntil, setValidityUntil] = useState('');
  const [theatreDetails, setTheatreDetails] = useState([]);
  const [isReadyForBooking, setIsReadyForBooking] = useState(false);
  const [datePickerOpen, setDatePickerOpen] = useState({
    theatreIdx: null,
    showIdx: null
  });

  const [availableLanguages, setAvailableLanguages] = useState([]);






  //   // Add this useEffect after your existing useEffects in your EditValidity component
  // useEffect(() => {
  //   if (validityFrom && validityUntil && theatreDetails.length > 0) {
  //     const allDatesInRange = getAllDatesInRange().map(date => formatDate(date));

  //     setTheatreDetails(prevDetails => 
  //       prevDetails.map(theatre => ({
  //         ...theatre,
  //         showTimes: theatre.showTimes.map(showtime => ({
  //           ...showtime,
  //           enabledDates: allDatesInRange // Auto-update to all dates in validity range
  //         }))
  //       }))
  //     );
  //   }
  // }, [validityFrom, validityUntil]); // Triggers when validity dates change


  // Initialize form with schedule data
  // useEffect(() => {
  //   if (schedule) {
  //     setValidityFrom(dayjs(schedule.validityFrom).format('YYYY-MM-DD'));
  //     setValidityUntil(dayjs(schedule.validityUntil).format('YYYY-MM-DD'));
  //     setIsReadyForBooking(
  //       schedule.theatreDetails.some(theatre => theatre.isReadyForBooking)
  //     );

  //     const updatedTheatreDetails = schedule.theatreDetails.map((theatre) => ({
  //       ...theatre,
  //       showTimes: (theatre.shows || []).map((show) => {
  //         const cleanedTime = show.time?.trim() || '';
  //         const regex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
  //         const match = cleanedTime.match(regex);

  //         if (match) {
  //           const [, hour, minute, period] = match;
  //           return {
  //             hour: String(hour).padStart(2, "0"),
  //             minute,
  //             period: period.toUpperCase(),
  //             language: show.language || '',
  //             format: show.format || '',
  //             enabledDates: show.enabledDates || []
  //           };
  //         }

  //         return { 
  //           hour: "00", 
  //           minute: "00", 
  //           period: "AM", 
  //           language: '', 
  //           format: '',
  //           enabledDates: []
  //         };
  //       })
  //     }));

  //     setTheatreDetails(updatedTheatreDetails);
  //   }
  // }, [schedule]);









  useEffect(() => {
    if (validityFrom && validityUntil && theatreDetails.length > 0) {
      const newDateRange = getAllDatesInRange().map(date => formatDate(date));
      let datesOutsideRange = [];
      
      // Collect all dates that would be removed
      theatreDetails.forEach((theatre, theatreIdx) => {
        theatre.showTimes.forEach((showtime, showIdx) => {
          const outsideDates = showtime.enabledDates.filter(date => !newDateRange.includes(date));
          if (outsideDates.length > 0) {
            datesOutsideRange.push(...outsideDates.map(date => ({
              date,
              theatreIdx,
              showIdx,
              theatreName: theatre.theatreId?.name,
              showTime: `${showtime.hour}:${showtime.minute} ${showtime.period}`
            })));
          }
        });
      });
      
      if (datesOutsideRange.length > 0) {
        const uniqueDates = [...new Set(datesOutsideRange.map(item => item.date))];
        const datesList = uniqueDates.map(date => moment(date).format('DD-MM-YYYY')).join(', ');
        
        const confirmRemoval = window.confirm(
          `⚠️ The following selected date(s) fall outside the new validity range and will be removed:\n\n${datesList}\n\nDo you want to continue?`
        );
        
        if (confirmRemoval) {
          // Remove dates outside the range
          const updatedTheatreDetails = theatreDetails.map(theatre => ({
            ...theatre,
            showTimes: theatre.showTimes.map(showtime => ({
              ...showtime,
              enabledDates: showtime.enabledDates.filter(date => newDateRange.includes(date))
            }))
          }));
          
          setTheatreDetails(updatedTheatreDetails);
        } else {
          // Revert the validity dates to their previous values
          // You might want to store previous values in state for this
          alert('Validity dates were not changed to preserve selected dates.');
        }
      }
    }
  }, [validityFrom, validityUntil]);
  




  // Initialize form with schedule data
  // useEffect(() => {
  //   if (schedule) {
  //     setValidityFrom(dayjs(schedule.validityFrom).format('YYYY-MM-DD'));
  //     setValidityUntil(dayjs(schedule.validityUntil).format('YYYY-MM-DD'));
  //     setIsReadyForBooking(
  //       schedule.theatreDetails.some(theatre => theatre.isReadyForBooking)
  //     );

  //     // Extract available languages from the movie
  //     setAvailableLanguages(schedule.movieId?.movieLanguages || []);

  //     const updatedTheatreDetails = schedule.theatreDetails.map((theatre) => ({
  //       ...theatre,
  //       showTimes: (theatre.shows || []).map((show) => {
  //         const cleanedTime = show.time?.trim() || '';
  //         const regex = /(\d{1,2}):(\d{2})\s*(AM|PM)/i;
  //         const match = cleanedTime.match(regex);

  //         if (match) {
  //           const [, hour, minute, period] = match;
  //           return {
  //             hour: String(hour).padStart(2, "0"),
  //             minute: minute || "00", // Ensure minute defaults to "00" if missing
  //             period: period.toUpperCase() || "AM",
  //             language: show.language || '',
  //             format: show.format || '',
  //             enabledDates: show.enabledDates || []
  //           };
  //         }

  //         return {
  //           hour: "00",
  //           minute: "00",
  //           period: "AM",
  //           language: '',
  //           format: '',
  //           enabledDates: []
  //         };
  //       })
  //     }));

  //     setTheatreDetails(updatedTheatreDetails);
  //   }
  // }, [schedule]);


  // useEffect(() => {
  //   if (!schedule) return;
  
  //   setValidityFrom(dayjs(schedule.validityFrom).format("YYYY-MM-DD"));
  //   setValidityUntil(dayjs(schedule.validityUntil).format("YYYY-MM-DD"));
  //   setIsReadyForBooking(
  //     schedule.theatreDetails.some(t => t.isReadyForBooking)
  //   );
  
  //   setAvailableLanguages(schedule.movieId?.movieLanguages || []);
  
  //   // ✅ only keep the clicked theatre if selectedTheatre exists
  //   const baseTheatres = selectedTheatre
  //     ? schedule.theatreDetails.filter(
  //         t => String(t.theatreId?._id || t.theatreId) ===
  //              String(selectedTheatre.theatreId?._id || selectedTheatre.theatreId)
  //       )
  //     : schedule.theatreDetails;
  
  //   const updatedTheatreDetails = baseTheatres.map(theatre => ({
  //     ...theatre,
  //     showTimes: (theatre.shows || []).map(show => {
  //       const cleanedTime = show.time?.trim() || "";
  //       const match = cleanedTime.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  
  //       if (match) {
  //         const [, hour, minute, period] = match;
  //         return {
  //           hour: String(hour).padStart(2, "0"),
  //           minute: minute || "00",
  //           period: (period || "AM").toUpperCase(),
  //           language: show.language || "",
  //           format: show.format || "",
  //           enabledDates: show.enabledDates || []
  //         };
  //       }
  
  //       return {
  //         hour: "00",
  //         minute: "00",
  //         period: "AM",
  //         language: "",
  //         format: "",
  //         enabledDates: []
  //       };
  //     })
  //   }));
  
  //   setTheatreDetails(updatedTheatreDetails);
  // }, [schedule, selectedTheatre]);



  useEffect(() => {
    if (!schedule) return;
  
    setValidityFrom(dayjs(schedule.validityFrom).format("YYYY-MM-DD"));
    setValidityUntil(dayjs(schedule.validityUntil).format("YYYY-MM-DD"));
    
    // ✅ REMOVE this line - don't set global isReadyForBooking based on any theatre
    // setIsReadyForBooking(schedule.theatreDetails.some(t => t.isReadyForBooking));
    
    setAvailableLanguages(schedule.movieId?.movieLanguages || []);
  
    const baseTheatres = selectedTheatre
      ? schedule.theatreDetails.filter(
          t => String(t.theatreId?._id || t.theatreId) ===
               String(selectedTheatre.theatreId?._id || selectedTheatre.theatreId)
        )
      : schedule.theatreDetails;
  
    const updatedTheatreDetails = baseTheatres.map(theatre => ({
      ...theatre,
      // ✅ Preserve the individual theatre's isReadyForBooking status
      isReadyForBooking: theatre.isReadyForBooking || false,
      showTimes: (theatre.shows || []).map(show => {
        const cleanedTime = show.time?.trim() || "";
        const match = cleanedTime.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  
        if (match) {
          const [, hour, minute, period] = match;
          return {
            hour: String(hour).padStart(2, "0"),
            minute: minute || "00",
            period: (period || "AM").toUpperCase(),
            language: show.language || "",
            format: show.format || "",
            enabledDates: show.enabledDates || []
          };
        }
  
        return {
          hour: "00",
          minute: "00",
          period: "AM",
          language: "",
          format: "",
          enabledDates: []
        };
      })
    }));
  
    setTheatreDetails(updatedTheatreDetails);
  }, [schedule, selectedTheatre]);
  





  // Handler functions
  const handleShowTimeChange = (theatreIdx, showIdx, field, value) => {
    const updated = [...theatreDetails];
    updated[theatreIdx].showTimes[showIdx][field] = value;
    setTheatreDetails(updated);
  };

  const handleDeleteShowTime = (theatreIdx, showIdx) => {
    if (window.confirm("Are you sure you want to delete this showtime?")) {
      const updated = [...theatreDetails];
      updated[theatreIdx].showTimes.splice(showIdx, 1);
      setTheatreDetails(updated);
    }
  };

  const handleAddShowTime = (theatreIdx, showIdx) => {
    const updated = [...theatreDetails];
    updated[theatreIdx].showTimes.splice(showIdx + 1, 0, {
      hour: "00",
      minute: "00",
      period: "AM",
      language: "",
      format: "",
      enabledDates: []
    });
    setTheatreDetails(updated);
  };

  const handleDateSelection = (theatreIdx, showIdx, dates) => {
    const updated = [...theatreDetails];
    updated[theatreIdx].showTimes[showIdx].enabledDates = dates.map(date => formatDate(date));
    setTheatreDetails(updated);
  };

  // Helper functions
  const formatDate = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  const getAllDatesInRange = () => {
    if (!validityFrom || !validityUntil) return [];

    const start = new Date(validityFrom);
    const end = new Date(validityUntil);
    const dates = [];

    let current = new Date(start);
    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const payload = {
  //       validityFrom,
  //       validityUntil,
  //       theatreDetails: theatreDetails.map((theatre) => ({
  //         theatreId: theatre.theatreId._id || theatre.theatreId,
  //         isArchived: theatre.isArchived || false,
  //         // isReadyForBooking: theatre.isReadyForBooking || false,
          
  //         isReadyForBooking: isReadyForBooking, // Use the state value directly
  //         shows: theatre.showTimes.map((showtime) => ({
  //           time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
  //           language: showtime.language,
  //           format: showtime.format,
  //           enabledDates: showtime.enabledDates || []
  //         }))
  //       })),
  //       // isReadyForBooking
  //       isReadyForBooking: isReadyForBooking, // Use the state value directly
  //     };

  //     const response = await showTimeServices.updateShowSchedule(schedule._id, payload);
  //     alert(response.message);
  //     navigate('/showSchedules');
  //   } catch (error) {
  //     console.error(error);
  //     alert('Failed to update show schedule');
  //   }
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // const payload = {
    //   validityFrom,
    //   validityUntil,
    //   theatreDetails: theatreDetails.map((theatre) => ({
    //     theatreId: theatre.theatreId._id || theatre.theatreId,
    //     isArchived: theatre.isArchived || false,
    //     isReadyForBooking: isReadyForBooking,
    //     shows: theatre.showTimes.map((showtime) => ({
    //       time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
    //       language: showtime.language,
    //       format: showtime.format,
    //       enabledDates: showtime.enabledDates || []
    //     }))
    //   })),
    //   isReadyForBooking: isReadyForBooking,
    //   forceUpdate: false
    // };


    const payload = {
      validityFrom,
      validityUntil,
      theatreDetails: theatreDetails.map((theatre) => ({
        theatreId: theatre.theatreId._id || theatre.theatreId,
        isArchived: theatre.isArchived || false,
        isReadyForBooking: theatre.isReadyForBooking || false, // ✅ USE INDIVIDUAL THEATRE VALUE
        shows: theatre.showTimes.map((showtime) => ({
          time: `${showtime.hour}:${showtime.minute} ${showtime.period}`,
          language: showtime.language,
          format: showtime.format,
          enabledDates: showtime.enabledDates || []
        }))
      })),
      forceUpdate: false
      // ❌ REMOVED: isReadyForBooking: isReadyForBooking
    };
  
    try {
      const response = await showTimeServices.updateShowSchedule(schedule._id, payload);
      
      // ✅ FIXED: Check for error message in successful response
      if (response.message && response.message.includes('❌ Cannot disable booking')) {
        const confirmMessage = `${response.message}\n\nDo you want to proceed and update only the booking status (Ready for Booking)?`;
        
        if (window.confirm(confirmMessage)) {
          try {
            const forcePayload = {
              ...payload,
              forceUpdate: true
            };
            
            const forceResponse = await showTimeServices.updateShowSchedule(schedule._id, forcePayload);
            alert(forceResponse.message);
            navigate('/showSchedules');
          } catch (forceError) {
            console.error('Force update failed:', forceError);
            alert('Failed to update show schedule');
          }
        }
      } else {
        // ✅ Normal success case
        alert(response.message);
        navigate('/showSchedules');
      }
      
    } catch (error) {
      console.error(error);
      alert('Failed to update show schedule');
    }
  };
  

  // Date Picker Modal Component
  // const DatePickerModal = ({ theatreIdx, showIdx, onClose, onSave }) => {
  //   const [selectedDates, setSelectedDates] = useState([
  //     ...theatreDetails[theatreIdx]?.showTimes[showIdx]?.enabledDates || []
  //   ]);

  //   const toggleDate = (date) => {
  //     const dateStr = formatDate(date);
  //     setSelectedDates(prev => 
  //       prev.includes(dateStr) 
  //         ? prev.filter(d => d !== dateStr)
  //         : [...prev, dateStr]
  //     );
  //   };

  //   const allDates = getAllDatesInRange();

  //   return (
  //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  //       <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
  //         <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>
  //         <div className="grid grid-cols-7 gap-1 mb-4">
  //           {allDates.map((date, idx) => {
  //             const dateStr = formatDate(date);
  //             const isSelected = selectedDates.includes(dateStr);
  //             return (
  //               <button
  //                 key={idx}
  //                 onClick={() => toggleDate(date)}
  //                 className={`p-2 border rounded ${
  //                   isSelected ? 'bg-blue-500 text-white' : 'bg-white'
  //                 }`}
  //               >
  //                 {date.getDate()}
  //                 <div className="text-xs">
  //                   {date.toLocaleString('default', { month: 'short' })}
  //                 </div>
  //               </button>
  //             );
  //           })}
  //         </div>
  //         <div className="flex justify-end gap-2">
  //           <button 
  //             onClick={onClose}
  //             className="px-4 py-2 bg-gray-300 rounded"
  //           >
  //             Cancel
  //           </button>
  //           <button 
  //             onClick={() => onSave(selectedDates)}
  //             className="px-4 py-2 bg-blue-500 text-white rounded"
  //           >
  //             Save
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };


  // const DatePickerModal = ({ theatreIdx, showIdx, onClose, onSave }) => {
  //   const allDates = getAllDatesInRange();
  //   const allDatesFormatted = allDates.map(date => formatDate(date));

  //   // Initialize with all dates selected by default
  //   const [selectedDates, setSelectedDates] = useState(allDatesFormatted);

  //   const toggleDate = (dateStr) => {
  //     setSelectedDates(prev => 
  //       prev.includes(dateStr)
  //         ? prev.filter(d => d !== dateStr) // Uncheck/remove date
  //         : [...prev, dateStr] // Check/add date
  //     );
  //   };

  //   return (
  //     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  //       <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
  //         <h3 className="text-lg font-bold mb-4">Select Dates to Exclude</h3>

  //         <div className="mb-4 p-3 bg-blue-50 rounded-lg">
  //           <p className="text-sm text-blue-800">
  //             All dates between {validityFrom} and {validityUntil} are selected by default.
  //             <br />
  //             <span className="font-medium">Uncheck dates you want to exclude.</span>
  //           </p>
  //         </div>

  //         <div className="grid grid-cols-7 gap-2 mb-4">
  //           {allDates.map((date, idx) => {
  //             const dateStr = formatDate(date);
  //             const isSelected = selectedDates.includes(dateStr);
  //             return (
  //               <label 
  //                 key={idx} 
  //                 className={`flex flex-col items-center p-2 rounded cursor-pointer border ${
  //                   isSelected ? 'bg-blue-100 border-blue-300' : 'bg-gray-50 border-gray-200'
  //                 }`}
  //               >
  //                 <input
  //                   type="checkbox"
  //                   checked={isSelected}
  //                   onChange={() => toggleDate(dateStr)}
  //                   className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
  //                 />
  //                 <span className={`mt-1 text-center text-sm ${isSelected ? 'font-medium' : 'text-gray-500'}`}>
  //                   {date.getDate()}
  //                 </span>
  //                 <span className="text-xs text-gray-500">
  //                   {date.toLocaleString('default', { month: 'short' })}
  //                 </span>
  //               </label>
  //             );
  //           })}
  //         </div>

  //         <div className="flex justify-between items-center">
  //           <span className="text-sm text-gray-600">
  //             {selectedDates.length} of {allDates.length} dates selected
  //           </span>
  //           <div className="flex gap-2">
  //             <button 
  //               onClick={onClose}
  //               className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
  //             >
  //               Cancel
  //             </button>
  //             <button 
  //               onClick={() => onSave(selectedDates)}
  //               className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
  //             >
  //               Save Selection
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };













  const DatePickerModal = ({ theatreIdx, showIdx, onClose, onSave }) => {
    const allDates = getAllDatesInRange();

    // Get the actual enabled dates for this specific showtime
    const currentEnabledDates = theatreDetails[theatreIdx]?.showTimes[showIdx]?.enabledDates || [];

    // Initialize with the actual enabled dates from the showtime, not all dates
    const [selectedDates, setSelectedDates] = useState([...currentEnabledDates]);

    const toggleDate = (dateStr) => {
      setSelectedDates(prev =>
        prev.includes(dateStr)
          ? prev.filter(d => d !== dateStr) // Uncheck/remove date
          : [...prev, dateStr] // Check/add date
      );
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg max-w-2xl max-h-[80vh] overflow-auto">
          <h3 className="text-lg font-bold mb-4">Select Enabled Dates</h3>

          <div className="mb-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-800">
              Select the dates when this showtime should be available.
              <br />
              <span className="font-medium">Check dates you want to include.</span>
            </p>
          </div>

          <div className="grid grid-cols-7 gap-2 mb-4">
            {allDates.map((date, idx) => {
              const dateStr = formatDate(date);
              const isSelected = selectedDates.includes(dateStr);
              return (
                <label
                  key={idx}
                  className={`flex flex-col items-center p-2 rounded cursor-pointer border ${isSelected ? 'bg-blue-100 border-blue-300' : 'bg-gray-50 border-gray-200'
                    }`}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggleDate(dateStr)}
                    className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                  />
                  <span className={`mt-1 text-center text-sm ${isSelected ? 'font-medium' : 'text-gray-500'}`}>
                    {date.getDate()}
                  </span>
                  <span className="text-xs text-gray-500">
                    {date.toLocaleString('default', { month: 'short' })}
                  </span>
                </label>
              );
            })}
          </div>

          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">
              {selectedDates.length} of {allDates.length} dates selected
            </span>
            <div className="flex gap-2">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={() => onSave(selectedDates)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save Selection
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };






  if (!schedule) {
    return <div className="text-red-500">No schedule selected</div>;
  }

  return (
    <div className="p-8 bg-white rounded-xl shadow-lg max-w-4xl mx-auto my-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Edit Show Schedule
        </h1>
        <p className="text-lg text-gray-600">
          Movie: <span className="font-semibold">{schedule.movieId?.name}</span>
        </p>
      </header>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Validity Dates */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Validity From
            </label>
            <input
              type="date"
              value={validityFrom}
              onChange={(e) => setValidityFrom(e.target.value)}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Validity Until
            </label>
            <input
              type="date"
              value={validityUntil}
              onChange={(e) => setValidityUntil(e.target.value)}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </section>

        {/* Theatre Details */}
        {theatreDetails.map((theatre, theatreIdx) => (
          <section key={theatreIdx} className="bg-gray-50 p-6 rounded-xl">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {theatre.theatreId?.name}
            </h2>

            <div className="space-y-4">
              {theatre.showTimes.map((showtime, showIdx) => (
                <div
                  key={showIdx}
                  className="grid grid-cols-1 md:grid-cols-5 gap-4 items-end"
                >
                  {/* Time Fields */}
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Hour</label>
                    <select
                      value={showtime.hour}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'hour', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      {[...Array(13).keys()].map((i) => (
                        <option key={i} value={String(i).padStart(2, "0")}>
                          {String(i).padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Minute</label>
                    <select
                      value={showtime.minute}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'minute', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      {[...Array(60).keys()].map((i) => (
                        <option key={i} value={String(i).padStart(2, "0")}>
                          {String(i).padStart(2, "0")}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">AM/PM</label>
                    <select
                      value={showtime.period}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'period', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>

                  {/* Language and Format */}
                  {/* <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Language</label>
                    <select
                      value={showtime.language}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'language', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      <option value="">Select</option>
                      {["Kannada", "Hindi", "Tamil", "Telugu", "English", "Malayalam"].map((lang) => (
                        <option key={lang} value={lang}>{lang}</option>
                      ))}
                    </select>
                  </div> */}

                  {/* Language and Format */}
                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Language</label>
                    <select
                      value={showtime.language}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'language', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      <option value="">Select</option>
                      {availableLanguages.map((lang) => (
                        <option key={lang} value={lang}>{lang}</option>
                      ))}
                    </select>
                  </div>


                  <div className="space-y-2">
                    <label className="text-sm font-medium text-gray-700">Format</label>
                    <select
                      value={showtime.format}
                      onChange={(e) => handleShowTimeChange(theatreIdx, showIdx, 'format', e.target.value)}
                      className="w-full p-2 border rounded-lg"
                    >
                      <option value="">Select</option>
                      <option value="2D">2D</option>
                      <option value="3D">3D</option>
                    </select>
                  </div>

                  {/* Date Selection */}
                  {/* <div className="space-y-2 col-span-2">
                    <button
                      type="button"
                      onClick={() => setDatePickerOpen({ theatreIdx, showIdx })}
                      className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200 w-full"
                    >
                      {showtime.enabledDates.length > 0 
                        ? `${showtime.enabledDates.length} dates selected` 
                        : "Select dates"}
                    </button>
                    <small className="text-gray-500 block truncate">
                      {showtime.enabledDates.length > 0 
                        ? showtime.enabledDates.join(', ') 
                        : 'Click to select dates'}
                    </small>
                  </div> */}


                  <div className="relative group w-full">
                    <button
                      type="button"
                      onClick={() => setDatePickerOpen({ theatreIdx, showIdx })}
                      className="p-2 border rounded-md bg-gray-100 hover:bg-gray-200 w-full"
                    >
                      {showtime.enabledDates.length > 0
                        ? `${showtime.enabledDates.length} dates selected`
                        : "Select dates"}
                    </button>

                    {/* Tooltip */}
                    {showtime.enabledDates.length > 0 && (
                      <div className="absolute left-0 top-full mt-1 z-10 hidden group-hover:block bg-gray-800 text-white text-xs rounded shadow-lg p-2 w-64 whitespace-normal break-words">
                        {showtime.enabledDates.map(date => moment(date).format('DD-MM-YYYY')).join(', ')}
                      </div>
                    )}
                  </div>


                  {/* Action Buttons */}
                  <div className="flex justify-center items-center space-x-4 col-span-3">
                    <button
                      type="button"
                      onClick={() => handleDeleteShowTime(theatreIdx, showIdx)}
                      className="text-red-500 hover:text-red-700 text-2xl flex items-center"
                      title="Delete showtime"
                    >
                      <FaTrashAlt className="mr-1" />
                    </button>

                    <button
                      type="button"
                      onClick={() => handleAddShowTime(theatreIdx, showIdx)}
                      className="text-green-500 hover:text-green-700 text-xl flex items-center"
                      title="Add showtime after"
                    >
                      <FaPlus className="mr-1" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}

        {/* Ready for Booking */}
        {/* <div className="flex items-center p-4 bg-gray-50 rounded-lg">
          <input
            type="checkbox"
            id="readyForBooking"
            checked={isReadyForBooking}
            onChange={(e) => setIsReadyForBooking(e.target.checked)}
            className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
          />
          <label htmlFor="readyForBooking" className="ml-3 text-sm font-medium text-gray-700">
            Ready for Booking
          </label>
          <span className="ml-2 text-xs text-gray-500">
            (Check this to make the movie immediately available for booking)
          </span>
        </div> */}










        {/* ✅ ADD THIS INSTEAD - Individual Theatre Ready for Booking Toggles */}
{theatreDetails.map((theatre, theatreIdx) => (
  <div key={theatreIdx} className="flex items-center p-4 bg-gray-50 rounded-lg mb-4">
    <input
      type="checkbox"
      id={`readyForBooking-${theatreIdx}`}
      checked={theatre.isReadyForBooking || false}
      onChange={(e) => {
        const updated = [...theatreDetails];
        updated[theatreIdx].isReadyForBooking = e.target.checked;
        setTheatreDetails(updated);
      }}
      className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
    />
    <label htmlFor={`readyForBooking-${theatreIdx}`} className="ml-3 text-sm font-medium text-gray-700">
      Ready for Booking - {theatre.theatreId?.name}
    </label>
    <span className="ml-2 text-xs text-gray-500">
      (Make this theatre available for booking)
    </span>
  </div>
))}

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full md:w-auto px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
        >
          Update Schedule
        </button>
      </form>

      {/* Date Picker Modal */}
      {datePickerOpen.theatreIdx !== null && datePickerOpen.showIdx !== null && (
        <DatePickerModal
          theatreIdx={datePickerOpen.theatreIdx}
          showIdx={datePickerOpen.showIdx}
          onClose={() => setDatePickerOpen({ theatreIdx: null, showIdx: null })}
          onSave={(dates) => {
            handleDateSelection(datePickerOpen.theatreIdx, datePickerOpen.showIdx, dates);
            setDatePickerOpen({ theatreIdx: null, showIdx: null });
          }}
        />
      )}
    </div>
  );
};

export default EditValidity;














// export default EditValidity;
